// @flow
import * as React from 'react'

import { useDuration } from '@toggl/ui'

type DurationProps = {
  since: number | null,
}

export function Duration(props: DurationProps) {
  const duration = useDuration(props.since)
  return <FormattedDuration duration={duration} />
}

type FormattedDurationProps = {
  duration: number,
}

export function FormattedDuration(props: FormattedDurationProps) {
  return formatDurationToHHMMSS(props.duration)
}

function formatDurationToHHMMSS(duration: number) {
  const hours = Math.floor(duration / 3600)
  const minutes = Math.floor((duration - hours * 3600) / 60)
  const seconds = duration - hours * 3600 - minutes * 60
  return `${hours}:${padTime(minutes)}:${padTime(seconds)}`
}

const padTime = (value: number) => value.toString().padStart(2, '0')
